import { savatarAxios as axios, checkAvailability as req } from '../utils/axiosInstances';
export function getHasAvatar(username) {
  return axios.get(username, { timeout: 1000 });
}
export function getCheckAvailability(username) {

  return req.get(username, {timeout:6000});
}
